export interface AuthorProfile {
  displayName: string;
  href: string | null;
  kind: "founder" | "editorial" | "unknown";
}

const normalizeAuthor = (author?: string | null) =>
  (author || "").trim().replace(/\s+/g, " ");

export const getAuthorProfile = (author?: string | null): AuthorProfile => {
  const normalizedAuthor = normalizeAuthor(author);
  const authorKey = normalizedAuthor.toLowerCase();

  if (authorKey.split(" ")[0] === "donnie") {
    return {
      displayName: "Donnie",
      href: "/about#donnie",
      kind: "founder",
    };
  }

  if (
    !normalizedAuthor ||
    authorKey === "elf letter team" ||
    authorKey === "elf letter bot team"
  ) {
    return {
      displayName: "Elf Letter Team",
      href: "/about#editorial",
      kind: "editorial",
    };
  }

  return {
    displayName: normalizedAuthor,
    href: null,
    kind: "unknown",
  };
};
